export const RED_700 = '#b91c1c';
export const GREEN_700 = '#37a04c';